import React, { Component } from 'react';
import { Dropdown,Icon, Modal, Button,Segment, Grid, Message } from 'semantic-ui-react';
import { getSKPD, getOPD } from '../../../../../_utils/localstorage';
import { BaseURLDev, headers } from '../../../../../_utils/config';
import moment from 'moment'
import printJS from 'print-js';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { DateRangePicker,isInclusivelyBeforeDay } from 'react-dates';
import { toIDR } from '../../../../../_utils/tocurrency';
import jsPDF from 'jspdf'
import { terbilang } from '../../../../../_utils/terbilang';
import swal from 'sweetalert';

export default class ExportSTS extends Component {

   constructor(props){
      super(props)
      this.state = {
         data:[],
         focused: null,
         focusedInput: null,
         startDate: null,
         endDate: null,
         total_all:0,
         export_process:false,
      }

      this.exportMode = this.exportMode.bind(this);
      this.exportToPDF = this.exportToPDF.bind(this);
   }

   filterData(opt){
      const { startDate,endDate,status_val,is_print_all } = this.state

      const start_date = startDate===null ? null : startDate.format('YYYY-MM-DD')
      const end_date = endDate===null ? null : endDate.format('YYYY-MM-DD')

      fetch(`${BaseURLDev}/report/sts/export?start=${start_date}&end=${end_date}&status=${status_val}&print_all=${is_print_all}`, { headers })
      .then(response => {
         if(!response.ok){
            this.setState({export_process:false})
            swal("Filter data gagal, periksa koneksi internet anda", {
               icon: "error",
            });
            return Promise.reject(response.statusText);
         }
         return response.json()
      })
      .then(resJSON => {
         if(resJSON.data.length===0){
            this.setState({export_process:false})
            swal("Data tidak ditemukan", {
               icon: "error",
            });
         }else{
            this.setState({data:resJSON.data, rentang:resJSON.rentang})
            if(opt==='excel') this.exportMode().toCSV('sts_id',`${moment().format("DD_MM_YYYY_HH_mm_ss")}`)
            
            else if(opt==='pdf') this.exportToPDF(`${moment().format("DD_MM_YYYY_HH_mm_ss")}`)

            else{
               printJS({
                  printable: 'data_print',
                  type: 'html',
                  modalMessage:"Sedang memuat data...",
                  showModal:true,
                  maxWidth:'1300',
                  font_size:'8pt',
                  documentTitle:`${moment().format('DD-MM-YYYY--HH:mm:ss')}`,
                  targetStyle: [
                     'margin',
                     'color',
                     'border-collapse',
                     'border-spacing',
                     'border-style',
                     'border-style',
                     'margin-bottom',
                     'padding',
                     'Label',
                     'background'
                  ]
               })
            }

            this.setState({export_process:false})
         }
      })
   }
   
   exportToPDF() {
      var pdf = new jsPDF('p', 'pt', 'letter');
         var source = document.getElementById("print_data");
         var specialElementHandlers = {
               '#bypassme': function (element, renderer) {
                  return true
               }
         };
         var margins = {
               top: 80,
               bottom: 60,
               left: 40,
               width: 522
         };
       
      pdf.fromHTML(
         source, // HTML string or DOM elem ref.
         margins.left, // x coord
         margins.top, { // y coord
               'width': margins.width, // max width of content on PDF
               'elementHandlers': specialElementHandlers
         },

         function (dispose) {
               pdf.save('Test.pdf');
         }, margins
      );
   }

   exportMode(){
      return {
         _fallbacktoCSV: true,  
         toXLS: function(tableId, filename) {   
            this._filename = (typeof filename === 'undefined') ? tableId : filename;
            if ((this._getMsieVersion() || this._isFirefox()) && this._fallbacktoCSV) {
               return this.toCSV(tableId);
            } else if (this._getMsieVersion() || this._isFirefox()) {
               alert("Not supported browser");
            }

            //Other Browser can download xls
            var htmltable = document.getElementById(tableId);
            var html = htmltable.outerHTML;

            this._downloadAnchor("data:application/vnd.ms-excel" + encodeURIComponent(html), 'xls'); 
         },
         toCSV: function(tableId, filename) {
            this._filename = (typeof filename === 'undefined') ? tableId : filename;
            // Generate our CSV string from out HTML Table
            var csv = this._tableToCSV(document.getElementById(tableId));
            // Create a CSV Blob
            var blob = new Blob([csv], { type: "text/csv" });

            // Determine which approach to take for the download
            if (navigator.msSaveOrOpenBlob) {
               // Works for Internet Explorer and Microsoft Edge
               navigator.msSaveOrOpenBlob(blob, this._filename + ".csv");
            } else {      
               this._downloadAnchor(URL.createObjectURL(blob), 'csv');      
            }
         },
         toPDF: function(tableId, filename) {
            this._filename = (typeof filename === 'undefined') ? tableId : filename;
            // Generate our CSV string from out HTML Table
            var pdf = document.getElementById(tableId);
            // Create a CSV Blob
            var blob = new Blob([pdf], { type: "text/pdf" });

            // Determine which approach to take for the download
            if (navigator.msSaveOrOpenBlob) {
               // Works for Internet Explorer and Microsoft Edge
               navigator.msSaveOrOpenBlob(blob, this._filename + ".pdf");
            } else {      
               this._downloadAnchor(URL.createObjectURL(blob), 'pdf');      
            }
         },
         _getMsieVersion: function() {
            var ua = window.navigator.userAgent;

            var msie = ua.indexOf("MSIE ");
            if (msie > 0) {
               // IE 10 or older => return version number
               return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)), 10);
            }

            var trident = ua.indexOf("Trident/");
            if (trident > 0) {
               // IE 11 => return version number
               var rv = ua.indexOf("rv:");
               return parseInt(ua.substring(rv + 3, ua.indexOf(".", rv)), 10);
            }

            var edge = ua.indexOf("Edge/");
            if (edge > 0) {
               // Edge (IE 12+) => return version number
               return parseInt(ua.substring(edge + 5, ua.indexOf(".", edge)), 10);
            }

            // other browser
            return false;
         },
         _isFirefox: function(){
            if (navigator.userAgent.indexOf("Firefox") > 0) {
               return 1;
            }

            return 0;
         },
         _downloadAnchor: function(content, ext) {
            var anchor = document.createElement("a");
            anchor.style = "display:none !important";
            anchor.id = "downloadanchor";
            document.body.appendChild(anchor);

            // If the [download] attribute is supported, try to use it
            if ("download" in anchor) {
               anchor.download = this._filename + "." + ext;
            }
            anchor.href = content;
            anchor.click();
            anchor.remove();
         },
         _tableToCSV: function(table) {
            // We'll be co-opting `slice` to create arrays
            var slice = Array.prototype.slice;

            return slice
            .call(table.rows)
            .map(function(row) {
               return slice
               .call(row.cells)
               .map(function(cell) {
                  return '"t"'.replace("t", cell.textContent);
               })
               .join(",");
            })
            .join("\r\n");
         }
      }
  }

   render() {
      
       const styletb = {
         borderCollapse:'collapse',
         borderSpacing:0,
         borderStyle:'solid',
         width:'100%',
      }

      var total_all = 0
      if(this.state.data.length>0){
         this.state.data.map(function(item){
            item.bp.map(function(bp){
               bp.rincian.map(function(rincian){
                  total_all += rincian.nilai
               })
            })
         })
      }

      return (
         
         <div>
            <Modal
               open={this.props.open}
               onClose={this.props.onClose}
               closeOnEscape={false}
               closeOnRootNodeClick={false}
               size="tiny"
            >
               <Modal.Header>
                  Export data
               </Modal.Header>
               
               <Modal.Content>
                  <Grid>
                     <Grid.Column width={16}>
                        <Segment loading={this.state.export_process}>
                           <p style={{marginBottom:'1px'}}>Rentang data yang akan diprint</p>
                           <DateRangePicker
                              verticalSpacing={7}
                              block
                              hideKeyboardShortcutsPanel
                              reopenPickerOnClearDates
                              showClearDates
                              showDefaultInputIcon
                              minimumNights={0}
                              displayFormat="DD/MM/YYYY"
                              small={true}                              
                              numberOfMonths={2}
                              startDatePlaceholderText="Awal"
                              endDatePlaceholderText="Akhir"
                              startDateId="startDateId"
                              endDateId="endDateId"
                              isOutsideRange={day => !isInclusivelyBeforeDay(day, moment())}
                              startDate={this.state.startDate}
                              endDate={this.state.endDate}
                              onDatesChange={({ startDate, endDate }) => this.setState({ startDate, endDate })}
                              focusedInput={this.state.focusedInput}
                              onFocusChange={(focusedInput) => this.setState({ focusedInput })}
                           />
                           <Message
                              error
                              header='** Penting!'
                              content='Jika (*rentang tanggal dikosongkan maka akan mengembalikan data hari ini'
                           />
                        </Segment>
                     </Grid.Column>                        
                  </Grid>
               </Modal.Content>
               <Modal.Actions>
                  <Button color='blue' size="small" onClick={()=>this.filterData('print')}> 
                     <p><Icon name='print' className='left floated' />Preview</p>
                  </Button>
                  <Button negative onClick={this.props.onClose}>Tutup</Button>                        
               </Modal.Actions>
               <div id="data_print" style={{height:0,width:'100%',overflow: 'hidden'}}>
                  <style dangerouslySetInnerHTML={{__html: `
                     @page{
                        size: 8.5 inches x 14 inches;
                        margin: default;
                     }
                  `}} /><div id="print_data">
                  <table align="center" width="100%" style={{fontSize:'14px'}}>
                     <tbody>
                        <tr align="center">
                           <th colSpan="4">
                              <p style={{fontSize:'18px',marginBottom: '25px'}}>BANK NTB<br />
                              REKAPITULASI SURAT TANDA SETORAN (STS)</p>
                           </th>
                        </tr>
                        <tr>
                           <td align="left">Terbilang</td>
                           <td align="left">&nbsp;:&nbsp;{terbilang(total_all)}</td>
                           <td align="right">Total</td>
                           <td align="left">&nbsp;:&nbsp;{toIDR(total_all)}</td>
                        </tr>
                        <tr>
                           <td colSpan="4"><b><i>Rentang waktu {this.state.rentang} denga rincian STS sebagai berikut</i> :</b></td>
                        </tr>
                     </tbody>
                  </table>
                  <table border="1" style={styletb} id="sts_id" align="center" width="100%">
                     <tbody>            
                        <tr style={{background:'#e5e5e5',padding:'4px'}}>
                           <th style={{padding:'4px'}}>No.</th>
                           <th style={{padding:'4px'}}>SKPD</th>
                           <th style={{padding:'4px'}}>OPD</th>
                           <th style={{padding:'4px'}}>Tanggal STS</th>
                           <th style={{padding:'4px'}}>Tanggal Realisasi</th>
                           <th style={{padding:'4px'}}>No.STS</th>
                           <th style={{padding:'4px'}}>Total</th>
                        </tr>
                        {this.state.data.map((item,i)=>{

                           return(<tr key={i}>
                              <td align="center" width="5%" style={{padding:'4px'}}>{i+1}.</td>
                              <td width="30%" style={{padding:'4px'}}>{getSKPD(item.skpd_str)}</td>
                              <td width="30%" style={{padding:'4px'}}>{getOPD(item.opd_str)}</td>
                              <td align="center" width="6%" style={{padding:'4px'}}>{moment(item.created_at).format("DD/MM/YYYY")}</td>
                              <td align="center" width="6%" style={{padding:'4px'}}>{
                                 moment(item.tgl_realisasi).format("DD/MM/YYYY")
                              }</td>
                              <td align="center" width="15%" style={{padding:'4px'}}>{item.no_sts}</td>
                              <RekeningTotal data={item.bp} />
                           </tr>)
                        })}
                     </tbody>            
                  </table></div>
               </div>
            </Modal>
         </div>
      );
   }
}

const RekeningTotal = (props) => {
   var count = 0
   props.data.map((item,i)=>(
      item.rincian.map((rek,ii)=>(
         count = count + rek.nilai
   ))))
   return(
         <td style={{padding:'4px'}}>{toIDR(count)}</td>
   )
}


// WEBPACK FOOTER //
// ./src/components/Content/views/bank/_sts/ExportSTS.js